export const extractHtmlFromRange = (range: Range): string => {
  const div = document.createElement('div');
  div.appendChild(range.cloneContents());
  return div.innerHTML;
};
